import React from 'react';
import {DetailsField} from 'components';

const hiddenLabelsForAvk = new Set<string>([
	'tags',
	'phaseIn',
	'phaseOut',
	'dateNewRegistration',
	'dateNewTypes',
	'requirements',
	'vehicleCategories',
	'driveVariants',
	'modelYear',
]);

export const useParagraphDetailsFields = ({
	rows,
	isAvkOrBav,
}: {
	rows: DetailsField[][];
	isAvkOrBav: boolean;
}): DetailsField[][] => {
	return React.useMemo(() => {
		if (!isAvkOrBav) return rows;
		return rows
			.map(row =>
				row.filter(field => !hiddenLabelsForAvk.has(field.key?.trim() ?? '')),
			)
			.filter(row => row.length > 0);
	}, [isAvkOrBav, rows]);
};
